var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleQuarter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.918 18.381C222.383 18.381 220.825 18.498 219.254 18.736C115.821 34.457 34.075 116.201 18.354 219.637C15.442 238.799 30.887 256 50.268 256H223.618C241.292 256 255.618 241.672 255.618 224V50.648C255.618 32.855 241.122 18.381 223.918 18.381ZM239.618 224C239.618 232.822 232.44 240 223.618 240H50.268C45.487 240 40.936 237.896 37.786 234.23C36.051 232.213 33.276 227.945 34.172 222.041C48.737 126.215 125.834 49.119 221.659 34.555C222.42 34.439 223.174 34.381 223.918 34.381C232.428 34.381 239.618 41.83 239.618 50.648V224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuarter);
export default __webpack_public_path__ + "static/media/circle-quarter.0775e88b88cb2a17261784a3828b5e58.svg";
export { ForwardRef as ReactComponent };